import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  LoginDetails: { authenticate: false },
  CleverDetails: {},
  StartCourse: {
    start: false
  }
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    LoginUser(state, action) {
      state.LoginDetails = action.payload;
    },
    CleverClientId(state, action) {
      state.CleverDetails = action.payload;
    },
    HandleCourse(state, action) {
      state.StartCourse = action.payload
    },
    ResetStartCourse(state) {
      state.StartCourse = { start: false };
    },
  },
});

export const { LoginUser, CleverClientId, HandleCourse, ResetStartCourse } = loginSlice.actions;

export default loginSlice.reducer;
